const REFERENCE_ASSETS = require('../reference-assets.json');

module.exports = {
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI',
        decimals: 1e18,
        address: '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
    },
};
